import { OrCondition } from './lib-feature-decision/conditions/or-condition';
import { ProvinceCondition } from './lib-feature-decision/conditions/province-condition';
import { SwitchCondition } from './lib-feature-decision/conditions/switch-condition';
import { TypeProjetCondition } from './lib-feature-decision/conditions/type-projet-condition';
import { UrlParamCondition } from './lib-feature-decision/conditions/url-param-condition';
import { ProvinceEnum } from './shared/constants/province.enum';
import { TypeProjet } from './shared/constants/type-projet.enum';

export namespace AppFeatures {
  export const ParcoursDSD = new SwitchCondition([
    new UrlParamCondition('visuel', 'DSD'),
    new TypeProjetCondition([TypeProjet.ExperimenteRemplacer, TypeProjet.ExperimenteSecondaire]),
    new ProvinceCondition(ProvinceEnum.Ontario)
  ]);
}
